/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCameraView = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8.465 2h7.07l2 3H22v8h-2V7h-3.535l-2-3h-4.93l-2 3H4v13h7v2H2V5h4.465zM12 10a3 3 0 0 0-1.984 5.25l-1.324 1.5a5 5 0 1 1 8.15-4.999l-1.937.498A3.002 3.002 0 0 0 12 10zm1.2 8.005c1.182 1.615 2.75 1.985 3.3 1.985h.039l.039.003c.75.058 1.48-.265 2.145-.809a6.179 6.179 0 0 0 1.113-1.212C18.807 16.397 17.17 16 16.5 16c-.793 0-1.556.362-2.23.903a6.48 6.48 0 0 0-1.07 1.102zm-.182-2.662C13.898 14.636 15.093 14 16.5 14c1.268 0 3.98.724 5.394 3.547l.234.468-.25.459a8.08 8.08 0 0 1-1.888 2.258c-.882.722-2.096 1.357-3.53 1.258-1.243-.016-3.74-.781-5.323-3.49l-.295-.505.295-.504a8.266 8.266 0 0 1 1.88-2.148z" />
        <path d="M17.75 18a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgCameraView as CameraView };
